// 菜单页面
import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Menu, App } from 'antd';
import { MenuList } from './menu_list'
import { basicPath } from '@/router/config'
import { getAllPromptQuantities } from '@/server/navigationBar.js'
import MessagePrompt from './messagePrompt'
import { getAllPermissions } from '@/server/home.js'
import { getAirportListApi, } from '@/server/new_pipeline_inspection.js'
import { getMapCenterPointApi } from '@/server/pipeline_overview.js'

function MenuPage (props) {
  const { message } = App.useApp();
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token');
  const [current, setCurrent] = useState(); //默认选中菜单
  const [menuList, setMenuList] = useState();
  const [menus, setMenus] = useState([]);//菜单路由
  const permissionsListArr = useRef() //所有权限
  const [showMenu, setShowMenu] = useState([]);
  const time1 = useRef();

  // 获取所有提示数量
  const getAllCont = (list) => {
    let arr = list;
    getAllPromptQuantities({
      access_token: token
    }).then((res) => {
      if (localStorage.getItem('dock_memberLevel') !== '255') {
        let ano = ['/', '/permission_settings']
        let newArr = []
        arr.forEach((item) => {
          if (ano.indexOf(item.key) > -1) {
            newArr.push(item)
          }
        })
        arr = arr.filter((item) => !newArr.some((ele) => ele.key === item.key))
      }
      if (permissionsListArr.current) {
        // if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '2').label = <MessagePrompt type='2' count={res.data.conventionalcheck_count} /> }
        // if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '3').label = <MessagePrompt type='3' count={res.data.leakcheck_count} /> }
        if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '1').label = <MessagePrompt type='1' count={res.data.conventionalcheck_count} /> }
        if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '4').label = <MessagePrompt type='4' count={res.data.risk_count} /> }
        if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '7').label = <MessagePrompt type='7' count={res.data.powergrid_count} /> }
        if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '8').label = <MessagePrompt type='8' count={res.data.tower_count} /> }
        if (permissionsListArr.current?.indexOf('') > -1 || true) { arr.find((item) => item.label.props?.type === '9').label = <MessagePrompt type='9' count={res.data.station_count} /> }
      }
      setShowMenu(addNewList(arr))
    })
  }

  // 处理不显示哪些菜单
  const chooseList = () => {
    let arr = [];
    if (localStorage.getItem('dock_companyType') === '1') {
      arr.splice(arr.findIndex((item) => item.key === '/AirportCamera'), 1)
      for (let i = 0; i < MenuList.length; i++) {
        console.log(MenuList[i].key);
        let key = MenuList[i].key;
        if (key !== '/AirportCamera') { arr.push(MenuList[i]); }
      }
    }
    if (localStorage.getItem('dock_companyType') === '2') {
      for (let i = 0; i < MenuList.length; i++) {
        let key = MenuList[i].key;
        if (key !== '/Video' && key !== '/record_command_flight' && key !== '/command_flight') {
          arr.push(MenuList[i]);
        }
      }
    }

    if (localStorage.getItem('dock_memberLevel') !== '255') {// 非公司账号需要隐藏的menu
      arr.splice(arr.findIndex((item) => item.key === '/GIS'), 1)
    }
    getAllCont(arr);

    time1.current = setInterval(() => {
      getAllCont(arr)
    }, 5000);
  }

  // 获取当前地图的默认中心位置
  const getDefaultMapPoints = async () => {
    let res = await getMapCenterPointApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg); return }
    window.localStorage.setItem('dock_DefaultMapPoints', JSON.stringify([Number(res.data.lat), Number(res.data.lon)]))
  }

  // 获取menu权限
  const getMenuPermissions = async () => {
    let res = await getAllPermissions({
      access_token: localStorage.getItem('dock_token'),
      member_level: localStorage.getItem('dock_memberLevel')
    })
    if (res.ret !== 200) { message.warning(res.msg); return }
    if (res.data.menu && res.data.menu.length) {
      permissionsListArr.current = res.data.menu
      window.localStorage.setItem('dock_AirportPermissionsArr', JSON.stringify(res.data.menuids));
      window.localStorage.setItem('dock_AirportPermissionsArrName', JSON.stringify(res.data.menuName));
    }
    chooseList()
  }

  // 遍历menu  并重新渲染
  const addNewList = (list) => {
    let menuArr = []
    for (let i = 0; i < list.length; i++) {
      if (list[i].children && list[i].children.length > 0 && (permissionsListArr.current?.indexOf(list[i].permissionkey) > -1 || list[i].permissionkey === '')) {
        let arr = addNewList(list[i].children)
        if (arr.length) {
          let sho = list[i]
          sho.children = arr
          menuArr.push(sho)
        }
      } else {
        if (permissionsListArr.current?.indexOf(list[i].permissionkey) > -1 || list[i].permissionkey === '') {
          menuArr.push(list[i])
        }
      }
    }
    return menuArr
  }
  // 点击菜单执行
  const onClick = async (e) => {

    if (e.key === '/pipeline_overview') {//GIS总览
      window.open(basicPath + '/pipeline_overview')
      return
    }


    setCurrent(e.key)
    if (e.key === '/login') {
      // 清理直播缓存
      localStorage.removeItem('dock_aliplayer_lang_data_h5_2_15_2_zh-cn');
      localStorage.removeItem('dock_aliplayer_lang_data_h5_2_9_17_zh-cn');
      localStorage.removeItem('dock_aliplayer_lang_data_h5_2_16_0_zh-cn');
      //地图缓存
      localStorage.removeItem('dock__AMap_WebGLRender');
      localStorage.removeItem('dock__AMap_AMap.Scale');

      //基础缓存
      localStorage.removeItem('dock_isLogin');
      localStorage.removeItem('dock_defaultOpenKeys');
      localStorage.removeItem('dock_CompanyID');
      localStorage.removeItem('dock_menuKey');
      localStorage.removeItem('dock_memberLevel');
      localStorage.removeItem('dock_companyType');
      localStorage.removeItem('dock_cruiseMenuKeys');
      localStorage.removeItem('dock_token');
      localStorage.removeItem('dock_AirportPermissionsArr');
      localStorage.removeItem('dock_type');
      message.success('退出成功');
      setTimeout(() => {
        navigate(e.key);
      }, 1500);
    } else if (e.key === '/FlightMap') {
      window.open(basicPath + '/FlightMap')
    } else if (e.key === '/command_flight') {//指令飞行
      window.open(basicPath + '/command_flight')
    } else {
      if (e.key === location.pathname) {
        return;
      }
      localStorage.setItem('dock_menuKey', e.key)
      navigate(e.key);
    }
  }
  useEffect(() => {
    //获取所有的菜单路由 如果跳转的路由不在菜单内则不切换菜单默认选中
    let arr = [];
    let list = [...MenuList]
    for (let i = 0; i < list.length; i++) {
      let val = list[i];
      arr.push(val.key);
      if (val.children && val.children.length > 0) {
        for (let n = 0; n < val.children.length; n++) {
          let nal = val.children[n];
          arr.push(nal.key);
        }
      }
    }
    setMenus([...arr]);
    if (localStorage.getItem('dock_token')) {
      getMenuPermissions()
      getDefaultMapPoints()
    }
    return () => {
      clearInterval(time1.current);
      time1.current = null;
    };
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (menus.indexOf(location.pathname) >= 0) { setCurrent(location.pathname); }
    if (menus.length === 0) setCurrent(location.pathname);

    //eslint-disable-next-line
  }, [location.pathname])


  return (
    <div style={{ height: '100%' }}>
      <Menu
        style={{ height: '100%', border: 0 }}
        selectedKeys={[current]}
        defaultOpenKeys={['video']}
        mode="inline"
        // items={menuList}
        items={showMenu}
        onClick={onClick}
      />
    </div>
  )
}
export default MenuPage




